import { User } from '@src/entities/User/ui/components/User';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React from 'react';

export function DisabledBulkActions() {
  return (
    <div style={{ height: '100%' }}>
      <Layout.Group alignItems="bottom" alignLayout="left" css={{ height: '100%' }} space={0}>
        <User.Capability attributes={['detach']} resource="ActionPaths">
          <DropdownMenu
            after={<IconSymbol icon="keyboard_arrow_down" />}
            before={<IconSymbol icon="grid_view" variant="outlined" />}
            className="disabled-bulk-actions"
            label="Bulk Actions"
          />
        </User.Capability>
      </Layout.Group>
    </div>
  );
}
